import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import TextField from 'material-ui/TextField';
import { FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';
import Logo from '../images/Formstack_Sign_Product_Logo.svg';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: '5%',
    fontFamily: theme.typography.fontFamily
  },
  paper: {
    padding: 16,
    textAlign: 'center',
    color: theme.palette.text.primary
  },
  loginInput: {
    marginBottom: '15px',
    width: '80%'
  },
  errorMessage: {
    color: '#E83030',
    margin: 0,
    fontSize: '0.75rem',
    minHeight: '1em',
    marginTop: '8px',
    marginBottom: '16px',
    fontFamily: 'Gudea',
    lineHeight: '1em'
  },
  button: {
    backgroundColor: '#0197EC',
    '&:hover': {
      backgroundColor: '#0197EC'
    }
  },
  img: {
    maxWidth: '100px'
  }
});

function LoginForm(props) {
  const {
    classes,
    onSubmit,
    onChange,
    hasError,
    hasHelperText,
    formError,
    isGroupLogin,
    groupLogin,
    onClick
  } = props;

  isGroupLogin
    ? localStorage.setItem('userGroup', true)
    : localStorage.removeItem('userGroup');

  return (
    <div className={classes.root}>
      {!props.isFsid ? (
        <Grid container spacing={24} justify="center">
          <Grid item xs={12} sm={6} md={4}>
            <Paper className={classes.paper}>
              <form action="/" onSubmit={onSubmit}>
                <img alt="Logo" src={Logo} className={classes.img} />
                <h3 className="card-heading">In-Person Signing </h3>
                <div>
                  <TextField
                    placeholder="Enter your email"
                    name="email"
                    type="text"
                    error={hasError}
                    onChange={onChange}
                    helperText={hasHelperText}
                    className={classes.loginInput}
                  />
                </div>
                {!props.checkSso && (
                  <div>
                    <TextField
                      placeholder="Enter your password"
                      name="password"
                      type="password"
                      error={formError && true}
                      onChange={onChange}
                      className={classes.loginInput}
                    />
                  </div>
                )}
                {props.formError && (
                  <p className={classes.errorMessage}>{formError}</p>
                )}
                {!props.checkSso && (
                  <Grid container direction="row">
                    <Grid item xs>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="isGroupLogin"
                            checked={isGroupLogin}
                            type="checkbox"
                            onChange={groupLogin}
                            color="primary"
                          />
                        }
                        label="Group Login"
                      />
                    </Grid>
                  </Grid>
                )}
                {!props.checkSso && (
                  <Grid container direction="row">
                    <Grid item xs>
                      <Button
                        type="submit"
                        variant="raised"
                        label="User Login"
                        color="primary"
                        fullWidth
                        classes={{ raised: classes.button }}
                        className={classes.button}
                      >
                        Login
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {props.checkSso && (
                  <Grid container direction="row">
                    <Grid item xs>
                      <Button
                        type="button"
                        variant="raised"
                        label="User Email"
                        color="primary"
                        fullWidth
                        classes={{ raised: classes.button }}
                        className={classes.button}
                        onClick={onClick}
                      >
                        Next
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </form>
            </Paper>
          </Grid>
        </Grid>
      ) : null}
    </div>
  );
}

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js